import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 12c0 -4.243 0 -6.364 1.318 -7.682s3.44 -1.318 7.682 -1.318s6.364 0 7.682 1.318s1.318 3.44 1.318 7.682s0 6.364 -1.318 7.682s-3.44 1.318 -7.682 1.318s-6.364 0 -7.682 -1.318s-1.318 -3.44 -1.318 -7.682","key":"svg-0"}],["path",{"d":"M6.316 8.21l5.684 7.58m-5.684 0l5.684 -7.58","key":"svg-1"}],["path",{"d":"M17.684 11.053v3.79c0 1.044 -.49 .946 -1.42 .946a2.368 2.368 0 0 1 0 -4.736zm0 0v-2.843","key":"svg-2"}]]

const IconBrandAdobeXd = createReactComponent('outline', 'brand-adobe-xd', 'BrandAdobeXd', __iconNode);

export default IconBrandAdobeXd;